import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { ROUTES } from "@/helpers/routes"
import styles from "./404.module.scss"

export const NotFound = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.notFound} role="alert">
      <h1 className={styles.title}>{t("notFound.title")}</h1>
      <Link to={ROUTES.HOME}>{t("notFound.cta")}</Link>
    </div>
  )
}
